import {Routes} from '@angular/router';
import {RegisterPageComponent} from './register-page.component';
import {VerifyRegistrationPageComponent} from './verify/verify-registration-page.component';
import {ResendRegistrationVerificationPageComponent} from './resend-verification/resend-verification-page.component';
import {AuthInfo} from '../../components/security/authorization/auth.guard';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
const routes: Routes = [{
    path: 'register',
    data: {auth: new AuthInfo({allowUnauthorizedUsers: true}), withSectionNav: false},
    children: [
        {path: '', component: RegisterPageComponent},
        {path: 'verify', component: VerifyRegistrationPageComponent},
        {path: 'resend-verification', component: ResendRegistrationVerificationPageComponent}
    ]
}];
export default routes;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/register/register-page.routing.ts